import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "add-member-modal__description" }

import { computed, ref } from 'vue'
import { useStore } from '@/store'

import { TeamInvite } from '@/store/teamInvite'
import { Membership, SendTeamInvite, TeamRole } from '@/types/membership'
import { SuccessMessages } from '@/data/messages'

import ModalHandlerService from '@/services/ModalHandlerService'
import BodyLockService from '@/services/BodyLockService'
import ToastNotificationService from '@/services/ToastNotificationService'

import AppTagInput from '@common/AppTagInput.vue'
import Modal from '@common/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    required: true
  },
  theme: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props



const store = useStore()
const activeMembership = computed<Membership>(() => store.getters['user/getActiveMembership'])
const activeTeamMembers = computed(() => store.getters['teams/getActiveTeamMembers'])
const pendingInvites = computed(() => store.getters['teams/getActiveTeamPendingInvites'])
const usersUpdating = ref<string[]>([])
const newPendingMembers = ref<string[]>([])
const asyncActionInProgress = ref(false)

const description = computed(() => props.theme ? 'The power is in numbers. Invite team members to your workspace by entering the email address in the field below.' : 'Enter the email addresses of the users to be invited')
const buttonText = computed(() => props.theme ? 'Skip' : 'Cancel')
const buttonTextPrimary = computed(() => props.theme ? 'Invite' : 'Send Invite')

const isUserInTeam = computed(() => activeTeamMembers.value?.map((member: Membership) => member.email)
  .some((newPendingMember: string) => newPendingMembers.value?.includes(newPendingMember)))

const isUserInPendingInvites = computed(() => pendingInvites.value?.map((member: Membership) => member.email)
  .some((newPendingMember: string) => newPendingMembers.value?.includes(newPendingMember)))

const teamInviteDisabled = computed(() => !newPendingMembers.value.length || isUserInTeam.value || isUserInPendingInvites.value)

function handleLowerCase(value: string[]) {
  newPendingMembers.value = value?.map((newPendingMember: string) => newPendingMember.toLowerCase())
}

const resetNewPendingMembers = () => {
  newPendingMembers.value = []
}

const handleCloseTeamInviteModal = () => {
  resetNewPendingMembers()
  ModalHandlerService.close()
}

const prepareInvitesForSending = () => {
  const pendingsUserMatchesNewMembers = store.getters['teams/getActiveTeamPendingInvites']
    .filter((user: TeamInvite) => [...newPendingMembers.value].includes(user.email))
    .map((user: TeamInvite) => { return user.email })

  const teamMembersMatchesNewMembers = store.getters['teams/getActiveTeamMembers']
    .filter((user: Membership) => [...newPendingMembers.value].includes(user.email))
    .map((user: Membership) => { return user.email })

  return [...newPendingMembers.value]
    .filter((v: string) => ![...pendingsUserMatchesNewMembers, ...teamMembersMatchesNewMembers]
      .includes(v))
}

const sendTeamInviteRequest = async (user?: TeamInvite) => {
  const usersNotExists = prepareInvitesForSending()
  if (user) usersUpdating.value.push(user.email)
  const userId: string = activeMembership.value?.userId

  const request: SendTeamInvite = {
    userId,
    sendTeamInviteRequest: {
      users: user ? [user.email] : usersNotExists,
      teamId: store.getters['user/getActiveMembership']?.teamId,
      role: user ? user.role as TeamRole : TeamRole.Member
    },
    resend: !!user
  }

  const message = user ? SuccessMessages.TEAM_MEMBER_RE_INVITED : usersNotExists.length > 1
    ? SuccessMessages.TEAM_MEMBERS_INVITED : SuccessMessages.TEAM_MEMBER_INVITED
  await store.dispatch('teams/sendTeamInvite', request)
  if (user) usersUpdating.value = usersUpdating.value.filter((email: string) => email !== user.email)
  ToastNotificationService.push({ type: 'info', message })
}

const sendTeamInvite = async () => {
  asyncActionInProgress.value = true
  setTimeout(() => {
    ModalHandlerService.close()
  }, 500)
  await sendTeamInviteRequest()
  BodyLockService.unlock()
  asyncActionInProgress.value = false
  resetNewPendingMembers()
}

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(Modal, {
    id: __props.id,
    title: "Invite users",
    onCloseModal: resetNewPendingMembers,
    theme: __props.theme
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        theme: "secondary",
        onClick: handleCloseTeamInviteModal
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_AppButton, {
        disabled: _unref(teamInviteDisabled),
        onClick: sendTeamInvite,
        loading: asyncActionInProgress.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(buttonTextPrimary)), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["add-member-modal", [__props.theme && `add-member-modal--${__props.theme}`]])
      }, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(description)), 1),
        _createVNode(AppTagInput, {
          class: "col-6",
          modelValue: newPendingMembers.value,
          "onUpdate:modelValue": handleLowerCase,
          id: "invite-members",
          label: __props.theme ? 'Email addresses' : null
        }, null, 8, ["modelValue", "label"])
      ], 2)
    ]),
    _: 1
  }, 8, ["id", "theme"]))
}
}

})